export default "__VITE_ASSET__lCakuL0U__"